<ion-card>
  <ng-template #fieldComponent></ng-template>
</ion-card>